module.exports = __webpack_public_path__ + "static/media/13.387400b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/13.png
// module id = 1386
// module chunks = 0